import { pluralize } from "@sellar-io/common";
import { Icon } from "../../../../../../../components";

const generateProductItemName = (productItemProperties: {
  containerType: string;
  volume: number;
  unit: string;
}) => {
  const { containerType, volume, unit } = productItemProperties;
  return `${volume}${unit} ${pluralize(containerType, 2)}`;
};

export const CaseSizeRuleStatus = ({
  caseSizeRules,
  enforceCaseSizeRules,
  onClick,
}: {
  caseSizeRules: {
    containerType: string;
    unit: string;
    volume: number;
    quantity: number;
  }[];
  enforceCaseSizeRules: boolean;
  onClick: () => void;
}) => {
  if (!caseSizeRules.length) {
    return null;
  }

  return (
    <div className="flex flex-col gap-y-2" onClick={onClick}>
      {caseSizeRules.map((rule) => {
        const productName = generateProductItemName(rule);
        const key =
          rule.containerType + rule.quantity + rule.unit + rule.volume;

        // case size rule enforced

        if (enforceCaseSizeRules) {
          return (
            <div
              className="grid cursor-pointer grid-cols-5 items-center gap-2 rounded-lg border border-solid border-indigo-200 bg-indigo-100 p-2"
              key={key}
            >
              <div className="col-span-5 inline text-indigo-800 md:col-span-3">
                You are <b>required</b> to order {productName} in full cases of{" "}
                {rule.quantity}
              </div>

              <div className="col-span-5 flex items-center justify-end gap-2 md:col-span-2">
                <Icon icon={"CHEVRON_RIGHT"} size={1} />
              </div>
            </div>
          );
        }

        // case size rule not enforced

        return (
          <div
            className="grid cursor-pointer grid-cols-5 items-center gap-2 rounded-lg border border-solid border-indigo-200 bg-indigo-100 p-2"
            key={key}
            onClick={onClick}
          >
            <div className="col-span-5 inline text-indigo-800 md:col-span-3">
              You are <b>advised</b> to order {productName} in full cases of{" "}
              {rule.quantity}
            </div>

            <div className="col-span-5 flex items-center justify-end gap-2 md:col-span-2">
              <Icon icon={"CHEVRON_RIGHT"} size={1} />
            </div>
          </div>
        );
      })}
    </div>
  );
};
